export function getSafeValueProvider(valueProvider) {
    if (typeof valueProvider === 'string') {
        return { type: valueProvider };
    }
    else {
        return valueProvider;
    }
}
